unit View.Servicos_Nacional.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UPersonalizacao_Tabela, UPersonalizacao_Tabela.Interfaces,
  UUtils, UWeb.Enum, UHelperServer, System.StrUtils, UConstantes;

type
  TFViewServicos_NacionalList = class(TForm)
    btNew: TButton;
    Servicos_NacionalDataset: TXDataWebDataSet;
    Servicos_NacionalDatasetid: TIntegerField;
    Servicos_NacionalDatasetcTribNac: TStringField;
    Servicos_NacionalDatasetdescricao: TStringField;
    Servicos_NacionalDatasetexcluido: TBooleanField;
    Servicos_NacionalDatasetinclusao: TDateTimeField;
    Servicos_NacionalDatasetalteracao: TDateTimeField;
    Servicos_NacionalDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure Servicos_NacionalDatasetdescricaoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewServicos_NacionalList: TFViewServicos_NacionalList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewServicos_NacionalList }

procedure TFViewServicos_NacionalList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewServicos_NacionalList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewServicos_NacionalList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewServicos_NacionalList, AElementID, Result, @AfterCreate);
end;

procedure TFViewServicos_NacionalList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewServicos_NacionalList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewServicos_NacionalList.Servicos_NacionalDatasetdescricaoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString);
end;

procedure TFViewServicos_NacionalList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewServicos_NacionalList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewServicos_NacionalList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Servicos_NacionalDataset.Connection.Model.DefaultSchema.FindEntityType(Servicos_NacionalDataset.EntitySetName),
      Servicos_NacionalDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_servicos_nacional');
  end;
end;

procedure TFViewServicos_NacionalList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['descricao']) of
      0: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewServicos_NacionalList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewServicos_NacionalList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('servicos_nacional', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Servicos_NacionalDataset,lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewServicos_NacionalList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Servicos_NacionalDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewServicos_NacionalList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.servicos_nacional.list.pagination.info');
  btNew := TButton.Create('view.servicos_nacional.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.servicos_nacional.list.table');
  cbPageSize := TComboBox.Create('view.servicos_nacional.list.cbPageSize');
  edSearch := TEdit.Create('view.servicos_nacional.list.search');
  lcPaginator := TListControl.Create('view.servicos_nacional.list.pagination');
  Servicos_NacionalDataset := TXDataWebDataSet.Create(Self);
  Servicos_NacionalDatasetid := TIntegerField.Create(Self);
  Servicos_NacionalDatasetcTribNac := TStringField.Create(Self);
  Servicos_NacionalDatasetdescricao := TStringField.Create(Self);
  Servicos_NacionalDatasetexcluido := TBooleanField.Create(Self);
  Servicos_NacionalDatasetinclusao := TDateTimeField.Create(Self);
  Servicos_NacionalDatasetalteracao := TDateTimeField.Create(Self);
  Servicos_NacionalDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Servicos_NacionalDataset.BeforeLoadDFMValues;
  Servicos_NacionalDatasetid.BeforeLoadDFMValues;
  Servicos_NacionalDatasetcTribNac.BeforeLoadDFMValues;
  Servicos_NacionalDatasetdescricao.BeforeLoadDFMValues;
  Servicos_NacionalDatasetexcluido.BeforeLoadDFMValues;
  Servicos_NacionalDatasetinclusao.BeforeLoadDFMValues;
  Servicos_NacionalDatasetalteracao.BeforeLoadDFMValues;
  Servicos_NacionalDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewServicos_NacionalList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cTribNac';
      Title := 'cTribNac';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Servicos_NacionalDataset.SetParentComponent(Self);
    Servicos_NacionalDataset.Name := 'Servicos_NacionalDataset';
    Servicos_NacionalDataset.EntitySetName := 'Servicos_Nacional';
    Servicos_NacionalDataset.Connection := DMConnection.ApiConnection;
    Servicos_NacionalDataset.Left := 72;
    Servicos_NacionalDataset.Top := 144;
    Servicos_NacionalDatasetid.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetid.Name := 'Servicos_NacionalDatasetid';
    Servicos_NacionalDatasetid.FieldName := 'id';
    Servicos_NacionalDatasetid.Required := True;
    Servicos_NacionalDatasetcTribNac.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetcTribNac.Name := 'Servicos_NacionalDatasetcTribNac';
    Servicos_NacionalDatasetcTribNac.FieldName := 'cTribNac';
    Servicos_NacionalDatasetcTribNac.Required := True;
    Servicos_NacionalDatasetcTribNac.Size := 255;
    Servicos_NacionalDatasetdescricao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetdescricao.Name := 'Servicos_NacionalDatasetdescricao';
    Servicos_NacionalDatasetdescricao.FieldName := 'descricao';
    Servicos_NacionalDatasetdescricao.Required := True;
    SetEvent(Servicos_NacionalDatasetdescricao, Self, 'OnGetText', 'Servicos_NacionalDatasetdescricaoGetText');
    Servicos_NacionalDatasetdescricao.Size := 255;
    Servicos_NacionalDatasetexcluido.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetexcluido.Name := 'Servicos_NacionalDatasetexcluido';
    Servicos_NacionalDatasetexcluido.FieldName := 'excluido';
    Servicos_NacionalDatasetinclusao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetinclusao.Name := 'Servicos_NacionalDatasetinclusao';
    Servicos_NacionalDatasetinclusao.FieldName := 'inclusao';
    Servicos_NacionalDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Servicos_NacionalDatasetalteracao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetalteracao.Name := 'Servicos_NacionalDatasetalteracao';
    Servicos_NacionalDatasetalteracao.FieldName := 'alteracao';
    Servicos_NacionalDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Servicos_NacionalDatasetexclusao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetexclusao.Name := 'Servicos_NacionalDatasetexclusao';
    Servicos_NacionalDatasetexclusao.FieldName := 'exclusao';
    Servicos_NacionalDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Servicos_NacionalDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Servicos_NacionalDataset.AfterLoadDFMValues;
    Servicos_NacionalDatasetid.AfterLoadDFMValues;
    Servicos_NacionalDatasetcTribNac.AfterLoadDFMValues;
    Servicos_NacionalDatasetdescricao.AfterLoadDFMValues;
    Servicos_NacionalDatasetexcluido.AfterLoadDFMValues;
    Servicos_NacionalDatasetinclusao.AfterLoadDFMValues;
    Servicos_NacionalDatasetalteracao.AfterLoadDFMValues;
    Servicos_NacionalDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
